<template>
  <div class="Company">
    <ld-header>{{ $t('A125', '公司信息') }}</ld-header>
    <div class="companyWrapper">
      <mescroll-vue ref="mescroll" :down="down">
        <div class="basic-info bg-white">
          <div class="comp white text-center round-md linear-main2">
            <!-- <img
          src="~Assets/images/user/comp_default_avatar.png"
          width="54"
        > -->
            <ld-icon class="main-color avatar" size="25" type="icongongsi" />
            <h3 class="font-lg font18">
              {{ vipCorp.fullname }}
            </h3>
            <div class="en-comp-name font-sm font12">
              {{ vipCorp.engName }}
            </div>
          </div>

          <div class="card-info">
            <div class="font-lg m-b-10">
              <img class="vertical-middle" src="~Assets/images/user/emp_info.png" width="22">
              职位信息
            </div>
            <van-row type="flex" gutter="18">
              <van-col span="8">
                <div class="card-item">
                  <img src="~Assets/images/user/department.png" width="20">
                  <div class="font12 mt5 m-b-10">
                    所在部门
                  </div>
                  <div class="font-lg">
                    {{ empInfo.deptName }}
                  </div>
                </div>
              </van-col>
              <van-col span="8">
                <div class="card-item">
                  <img src="~Assets/images/user/emp_card.png" width="20">
                  <div class="font12 mt5 m-b-10">
                    工号
                  </div>
                  <div class="font-lg">
                    {{ empInfo.empNo }}
                  </div>
                </div>
              </van-col>
              <van-col span="8">
                <div class="card-item">
                  <img src="~Assets/images/user/level.png" width="20">
                  <div class="font12 mt5 m-b-10">
                    差标等级
                  </div>
                  <div class="font-lg">
                    {{ empInfo.empRankName }}
                  </div>
                </div>
              </van-col>
            </van-row>
          </div>
        </div>

        <div class="travel-info">
          <div class="title font-lg">
            <img class="vertical-middle" src="~Assets/images/user/travel_info.png" width="22">
            差旅信息
          </div>

          <van-cell-group>
            <van-cell title="审批规则">
              暂无参数
            </van-cell>
            <van-cell :title="$t('K001', '成本中心')">
              {{ empInfo.costCenterName }}
            </van-cell>
            <van-cell title="代订范围">
              <span v-if="empInfo.bookRange == 0">为本人预订</span>
              <span v-else-if="empInfo.bookRange == 1">为本部门预订</span>
              <span v-else>为全公司预订</span>
            </van-cell>
            <van-cell title="为外来人预订">
              <span v-if="empInfo.bookOutside == 0">否</span>
              <span v-else>是</span>
            </van-cell>
            <van-cell title="是否审批人">
              <span v-if="empInfo.ifApprover == 0">否</span>
              <span v-else>是</span>
            </van-cell>
            <van-cell title="作为预订人审批属性">
              <span v-if="empInfo.appBook == 0">审批</span>
              <span v-else>免审</span>
            </van-cell>
            <van-cell title="作为出行人审批属性">
              <span v-if="empInfo.appTravel == 0">审批</span>
              <span v-else>免审</span>
            </van-cell>
          </van-cell-group>
        </div>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Cell, CellGroup } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'

export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    MescrollVue
  },
  data () {
    return {
      down: { use: false }
    }
  },
  methods: {
  },
  computed: {
    ...mapState({
      empInfo: state => state.app.userInfo.empInfo,
      vipCorp: state => state.app.userInfo.vipCorp,
    })
  }
}
</script>

<style lang="less">
.Company {
  .basic-info {
    padding: 10px 15px 20px;

    .comp {
      padding: 20px 0;
      background-size: 100%;

      .avatar {
        display: inline-block;
        padding: 10px;
        background-color: #fff;
        border-radius: 50%;
      }

      h3 {
        margin-top: 10px;
        margin-bottom: 0;
      }

      .en-comp-name {
        margin-top: 3px;
        letter-spacing: 5px;
      }
    }

    .card-info {
      margin-top: 20px;

      .card-item {
        text-align: center;
        padding: 20px 0;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
      }
    }
  }

  .travel-info {
    margin-top: 5px;

    .title {
      padding: 6px 15px;
      background-color: #fff;
    }

    .van-cell {
      padding: 16px;
    }
  }

  .companyWrapper {
    height: calc(100vh - 46px);
    overflow: hidden;
  }
}

.m-b-10 {
  margin-bottom: 10px;
}
</style>


